import P from '../../pages';
import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { defaultMessages } from '../../../../libs/i18n/default';
import ReactOnRails from 'react-on-rails';
import FormHeader from './FormHeader';
import Redirector from './Redirector';
import Button from 'react-bootstrap/lib/Button';
import { Redirect } from 'react-router-dom';
import Alert from './Alert';
import ButtonGroup from './ButtonGroup';
import Form from 'react-bootstrap/lib/Form';
import ControlLabel from 'react-bootstrap/lib/ControlLabel';
import ReactMarkdown from 'react-markdown';
import Info from 'react-icons/lib/fa/info-circle';
import CustomFormGroup from './CustomFormGroup';
import CheckboxOrRadioGroup from './CheckboxOrRadioGroup';
import { validator, fieldsToValidate, pageValid, executeValidations } from '../../validator';
import { handleSelection, changeState, generateProfileElementObject } from '../../utilities';

class GuestPackages extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      page: this.props.page,
      serviceLevel: generateProfileElementObject(this.props.profileElements, this.props.activeProfileElements, [], 'service', 'service_level')
    };
    this.handleProductsOfferedSelection = this.handleProductsOfferedSelection.bind(this);
    this.submit = this.submit.bind(this);
    this.back = this.back.bind(this);
  }

  componentWillMount(){
    executeValidations(this)
  }

  changeState = async(id, val) => {
    changeState(this, id, val)
  }

  handleProductsOfferedSelection(e){
    this.changeState('serviceLevel', handleSelection(this.state.serviceLevel.val, e.target.value))
  }

  back(e) {
    e.preventDefault();
    this.props.onGoBack();
  }

  submit(e) {
    this.props.onGuestPackagesSubmit({
      serviceLevel: this.state.serviceLevel.val,
      host_id: this.props.user.host.id,
    });
  }

  render() {
    const thisPage = P.GUEST_PACKAGES_PAGE;
    const { formatMessage } = this.props.intl;
    const content = this.props.content;
    const page = this.props.page;
    const productSelections = [...new Set(this.props.user.host.product_options.map(t => t.kind).filter(t => t != 'other'))]

    return (
      <div id={page} className='profile'>
        <Redirector this_page={thisPage} page={page}/>
        <form onSubmit={this.submit}>
          <FormHeader title={content.pages.guest_packages.title} icon={<Info />}/>

          <CustomFormGroup valid={this.state.serviceLevel.valid}>
            <ReactMarkdown source={content.pages.guest_packages.body} />
            <ControlLabel>{formatMessage(defaultMessages.clientHostPagesGuestPackagesLabelsProductsOffered)}</ControlLabel>
            <div className="checkbox">
              {['complete','traditional','dinneronly','breakfastonly','nomeals'].filter(i => productSelections.includes(i)).map((opt) => (
                <ControlLabel key={opt} className="checkbox">
                  <input
                    className="form-checkbox"
                    name={'serviceLevel'}
                    id={'serviceLevel_'+opt.split(' ').join('_').toLowerCase()}
                    onChange={this.handleProductsOfferedSelection}
                    value={opt}
                    checked={ this.state.serviceLevel.val.includes(opt) }
                    type={'checkbox'} />
                  <ReactMarkdown className="product-explanation" source={content.pages.service_level_options[opt]} />
                </ControlLabel>
              ))}
            </div>
          </CustomFormGroup>

          { content.territory_code != "asc" && <Alert alert={content.pages.guest_packages.info} /> }

          <ButtonGroup
            backFunc={this.back}
            submitFunc={this.submit}
            disableSubmit={!pageValid(this.state, this.props.requiredFields)}
            page={thisPage}
            user={this.props.user}
            intl={this.props.intl} />

        </form>
      </div>
    );
  }
}

GuestPackages.propTypes = {
   onGuestPackagesSubmit: PropTypes.func,
   onSkipSubmit: PropTypes.func,
   onGoBack: PropTypes.func,
   page: PropTypes.string,
   intl: PropTypes.object,
   content: PropTypes.object
};

export default injectIntl(GuestPackages);
